import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { RawInput } from '../InputText';
import * as Styles from './index.styles';

const { StyledInputPassword } = Styles;

export const InputPassword = ({ className, fullWidth, icon, ...otherProps }) => {
    const [hidden, setHidden] = useState(true);

    return (
        <StyledInputPassword className={className} fullWidth={fullWidth}>
            <RawInput
                type={hidden ? 'password' : 'text'}
                fullWidth={fullWidth}
                {...otherProps}
                icon={
                    icon ? (
                        <Icon
                            onClick={() => setHidden(!hidden)}
                            icon={['fas', `${hidden ? 'eye-slash' : 'eye'}`]}
                        />
                    ) : null
                }
            />
        </StyledInputPassword>
    );
};

InputPassword.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.bool,
    fullWidth: PropTypes.bool,
};

InputPassword.defaultProps = {
    className: '',
    icon: true,
    fullWidth: false,
};

InputPassword.Styles = Styles;
